export default [
  {
    path: '/admin/settings',
    name: 'indexSettingsAdmin',
    meta: { title: 'indexSettingsAdmin' },
    component: () => import('@/pages/admin/settings'),
  },
]
